// in src/Menu.js
import * as React from 'react';
import { createElement } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, getResources, usePermissions } from 'react-admin';
import { withRouter } from 'react-router-dom';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';

const Menu = ({ onMenuClick, logout }) => {
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const open = useSelector(state => state.admin.ui.sidebarOpen);
    const resources = useSelector(getResources);

    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const sourcesAdminPermissions = ['customers', 'locations', 'contacts', 'inspections', 'users', 'inspectors', 'systems'];
    const sourcesUserPermissions = ['customers', 'locations', 'contacts', 'inspections'];

    return (
        <div>
            <MenuItemLink
                to="/"
                primaryText="Dashboard"
                leftIcon={<DashboardIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            {resources.map(resource => {
                if (isAdmin) {
                    if (sourcesAdminPermissions.includes(resource.name)) {
                        return (
                            <MenuItemLink
                                key={resource.name}
                                to={`/${resource.name}`}
                                primaryText={resource.name.charAt(0).toUpperCase() + resource.name.slice(1)}
                                leftIcon={createElement(resource.icon)}
                                onClick={onMenuClick}
                                sidebarIsOpen={open}
                            />
                        )
                    }
                } else {
                    if (sourcesUserPermissions.includes(resource.name)) {
                        return (
                            <MenuItemLink
                                key={resource.name}
                                to={`/${resource.name}`}
                                primaryText={resource.name.charAt(0).toUpperCase() + resource.name.slice(1)}
                                leftIcon={createElement(resource.icon)}
                                onClick={onMenuClick}
                                sidebarIsOpen={open}
                            />
                        )
                    }
                }

            })}
            <MenuItemLink
                to="/settings"
                primaryText="Settings"
                leftIcon={<SettingsIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            {isXSmall && logout}
        </div>
    );
}

export default withRouter(Menu);